export default __webpack_public_path__ + "static/media/uae-dirham.05d620d4.svg";